"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.JavaScriptObfuscator = void 0;
require("reflect-metadata");
const ServiceIdentifiers_1 = require("./container/ServiceIdentifiers");
const InversifyContainerFacade_1 = require("./container/InversifyContainerFacade");
const Options_1 = require("./options/Options");
const Utils_1 = require("./utils/Utils");
class JavaScriptObfuscatorFacade {
    static obfuscate(sourceCode, inputOptions = {}) {
        const inversifyContainerFacade = new InversifyContainerFacade_1.InversifyContainerFacade();
        inversifyContainerFacade.load(sourceCode, '', inputOptions);
        const javaScriptObfuscator = inversifyContainerFacade.get(ServiceIdentifiers_1.ServiceIdentifiers.IJavaScriptObfuscator);
        const obfuscationResult = javaScriptObfuscator.obfuscate(sourceCode);
        inversifyContainerFacade.unload();
        return obfuscationResult;
    }
    static obfuscateMultiple(sourceCodesObject, inputOptions = {}) {
        if (typeof sourceCodesObject !== 'object') {
            throw new Error('Source codes object should be a plain object');
        }
        return Object.keys(sourceCodesObject).reduce((acc, sourceCodeIdentifier, index) => {
            const identifiersPrefix = Utils_1.Utils.getIdentifiersPrefixForMultipleSources(inputOptions.identifiersPrefix, index);
            const sourceCode = sourceCodesObject[sourceCodeIdentifier];
            const sourceCodeOptions = {
                ...inputOptions,
                identifiersPrefix
            };
            return {
                ...acc,
                [sourceCodeIdentifier]: JavaScriptObfuscatorFacade.obfuscate(sourceCode, sourceCodeOptions)
            };
        }, {});
    }
    static getOptionsByPreset(optionsPreset) {
        return Options_1.Options.getOptionsByPreset(optionsPreset);
    }
    static async obfuscatePro(sourceCode, inputOptions, proApiConfig, onProgress) {
        if (typeof window !== 'undefined') {
            const { ApiError } = await Promise.resolve().then(() => __importStar(require('./pro-api/ApiError')));
            throw new ApiError('obfuscatePro is only available in Node.js environment', 500);
        }
        const { ProApiClient } = await Promise.resolve().then(() => __importStar(require('./pro-api/ProApiClient')));
        const client = new ProApiClient(proApiConfig);
        const options = await client.resolveOptions(inputOptions);
        if (!ProApiClient.hasProFeatures(options)) {
            return JavaScriptObfuscatorFacade.obfuscate(sourceCode, options);
        }
        return client.obfuscate(sourceCode, options, onProgress);
    }
}
exports.JavaScriptObfuscator = JavaScriptObfuscatorFacade;
JavaScriptObfuscatorFacade.version = (_a = process.env.VERSION) !== null && _a !== void 0 ? _a : 'unknown';
var ApiError_1 = require("./pro-api/ApiError");
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return ApiError_1.ApiError; } });
